/* istanbul ignore file */
export { default } from './SimpleAccordion';
